/* global axios */
import ApiClient from '../ApiClient';

// Porteira de troca de senha para quem recebeu senha definida por um administrador. Não pede a
// senha atual: a trava é no servidor, que só aceita enquanto a marca de troca obrigatória existir.
class TrocaSenhaAPI extends ApiClient {
  constructor() {
    super('profile', { accountScoped: false, apiVersion: 'v1' });
  }

  trocar(password) {
    return axios.post(`${this.url}/trocar_senha_obrigatoria`, { password });
  }
}

export default new TrocaSenhaAPI();
